























































import {Component, Prop, Vue} from 'vue-property-decorator'
import { PropType } from 'vue'

interface ConfirmContents {
    [index: number]: { title: string; value: string};
}

@Component
export default class ConfirmModal extends Vue {

    isClicked = false

    @Prop({
        required: true,
        type: Array as PropType<ConfirmContents>
    })
    private checkContents?: []

    @Prop({
        required: false,
        type: String,
        default: 'この内容でよろしいですか？'
    })
    private checkTitle?: string

    clickYes() {
        if (this.isClicked) {
            return
        }

        this.isClicked = true
        this.$emit('clickYes')
    }

}
